const PATH = 'fe.components.measure.observation_scores';

const messages = {
  notScored: {
    key: `${PATH}.not_scored`,
    defaultValue: 'Not scored'
  },
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Observation Scores'
  },
  titleInformal: {
    key: `${PATH}.title_informal`,
    defaultValue: 'Observation Ranges'
  }
};

export default messages;
